// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3zvSg","header":"ClearentDisclaimer_header__1PT1r","inner":"ClearentDisclaimer_inner__YoJ2T"};